// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__28Zhr","inner":"Form_inner__18-w6","range":"Form_range__3JdmD","name":"Form_name__RFg4H","actions":"Form_actions__atw-r"};